import React from 'react';
import { Field, useFormikContext } from 'formik';

import {
  InputUI,
  AutoCompleteSelectUI,
  AutoCompleteSelectServiceUI,
  FormErrorUI,
  FormLabelUI,
  CheckboxUI,
} from '../Interface';
import { itemAutocompleteRequestBuilder, itemAutocompleteService } from '../../utils/itemAutocomplete';

const ItemCompanyCatalogFields = ({ viewField, autocompleteOptions, selectedValues }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="itemCode"
          component={AutoCompleteSelectServiceUI}
          fullWidth
          label={<FormLabelUI text="Cikkszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemCode} />}
          service={itemAutocompleteService}
          serviceRequestBuilder={itemAutocompleteRequestBuilder}
          onChange={async (_e, newVal) => {
            await setFieldValue('itemCode', newVal?.value ?? null);
            await validateField('itemCode');
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.itemCode) }}
          selectedValue={values.itemCode}
          selectedLabelValue={selectedValues?.itemCode || values.itemCode || ''}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="companyId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Cég" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.companyId} />}
          onChange={(_e, newVal) => {
            setFieldValue('companyId', newVal?.value ?? null).then(() => {
              validateField('companyId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.companyId !== null }}
          selectedValue={values.companyId}
          selectedLabelValue={autocompleteOptions?.company?.find((item) => item.value === values.companyId)?.label || ''}
          dataset={autocompleteOptions?.company}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="itemCodeInBp"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="ÜP cikkszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemCodeInBp} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.itemCodeInBp) }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="itemNameInBp"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="ÜP cikk név" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemNameInBp} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.itemNameInBp) }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="note"
          as={InputUI}
          className={`${viewField ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          multiline
          rows={4}
          label={<FormLabelUI text="Megjegyzés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.note} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.note) }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default ItemCompanyCatalogFields;
